import './nextevents.css'
import { useNavigate } from 'react-router-dom'

export type EventItem = {
    day?: string,
    date: string,
    month: string,
    description: string
    event?: (e: EventItem) => void
}

interface Props {
    events: EventItem[]
}

export const NextEvents = ({ events }: Props) => {

    function getMonthName(monthNumber: number) {
        const months = [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ];

        return months[monthNumber];
    }

    const today = new Date();
    const navigate = useNavigate();
    return (
        <div className="list_container cursor-pointer" onClick={() => { 
            navigate("/app/admin/calendar") 
            }}>
            <div className="card_title">Próximos Eventos</div>
            <div className="events_wrapper">
                {events.length === 0 ? (
                    <div className="event_item no_event">
                        <div className="date_container">
                            <span>{today.getDate()}</span>
                            <span>{getMonthName(today.getMonth())}</span>
                        </div>
                        <div className="event_description">
                            No hay eventos hoy
                        </div>
                    </div>
                ) : (
                    events.map((event, index) => (
                        <div key={index} className="event_item" onClick={() => event.event?.(event)}>
                            <div className="date_container">
                                <span>{event.date}</span>
                                <span>{event.month}</span>
                            </div>
                            <div className="event_description">
                                {event.description}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};
